import { render } from "./AppMessageShareSettings.vue?vue&type=template&id=b819c3a0&scoped=true&ts=true"
import script from "./AppMessageShareSettings.vue?vue&type=script&lang=ts"
export * from "./AppMessageShareSettings.vue?vue&type=script&lang=ts"

import "./AppMessageShareSettings.vue?vue&type=style&index=0&id=b819c3a0&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b819c3a0"]])

export default __exports__